
// var img = document.querySelector("#slider-product .slider-product-recommendation .slick-list .slick-track .slick-slide .grid__item .card-wrapper .card .card__inner a .card__media .media");
// var img_element = $("#slider-product .slider-product-recommendation .slick-list .slick-track .slick-slide .grid__item .card-wrapper .card .card__inner a .card__media .media").get();

// console.log(img);



$(document).ready(function(){
  $("#color_family").text($("#color_caja").text() + " / " + $("#color_tablero").text());
  
  $(".slider-product-recommendation").slick({
    infinite: false,
    arrows: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
    prevArrow: "<button type='button' class='slick-next-arrow'><img src='https://cdn.shopify.com/s/files/1/0296/3498/6116/files/left.svg?v=1653673952' alt='Slider Siguiente'/></button>",
    nextArrow: "<button type='button' class='slick-prev-arrow'><img src='https://cdn.shopify.com/s/files/1/0296/3498/6116/files/right.svg?v=1653673952' alt='Slider Anterior'/></button>",
    autoplaySpeed: 4000,
    autoplay: false,
    responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                      infinite: false,
                      slidesToShow: 3,
                      slidesToScroll: 1,
                      infinite: true,
                      dots: false,
                      arrows: true,
                      autoplay: true
                  }
                },
                {
                breakpoint: 768,
                  settings: {
                      infinite: false,
                      slidesToShow: 2,
                      slidesToScroll: 1,
                      dots: false,
                      arrows: false,
                      autoplay: true
                  }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ]
    });
  
  
  if($(window).width() <= 768){
    var mySwiperMobileSliderProduct = new Swiper('.container-mobile-main-image', {
        // Optional parameters
        direction: 'horizontal',
        speed: 400,
        zoom: {
          maxRatio: 3,
          toggle: true
        },
        loop: false,
        resistanceRatio: 0, // evita tirones
        followFinger: true,
        threshold: 10,
        // autoplay: {
        //   delay: 3000
        // },
      
        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
        }
    });
  }

  // if(window.innerWidth > 1024) {
  //  $( ".image-zoom" ).hover(function() {  
  //     var drift = new Drift(document.querySelector(".image-zoom-"+$(this).attr("id")), {
  //       paneContainer: document.querySelector(".image-details-"+$(this).attr("id"))
  //     });
      
  //     drift.enable();
  //     $('#ProductInfo-template--16523264491779__main').css("z-index", "1");
  //     $('.image-details-'+$(this).attr("id")).css("z-index", "10");
  //     $('.image-details-'+$(this).attr("id")).attr('style', 'display: block !important');
  //   });
  
  //   $( ".image-zoom" ).mouseout(function() {
  //      $('#ProductInfo-template--16523264491779__main').css("z-index", "9");
  //      $('.image-details-'+$(this).attr("id")).attr('style', 'display: none !important');
  //   });
  // }
});
